import { useQuery } from '@tanstack/react-query';
import type { VisibilityReportsPageResponse } from '@brand24-original/llm-types';
import { getVisibilityReports } from '../../services/visibility-report/VisibilityReportService';
import { GET_VISIBILITY_REPORTS } from '../../query/visibility-report/keys';

export const useGetVisibilityReports = (
  projectId: number | null,
  page: number,
  pageSize: number
) => {
  return useQuery<VisibilityReportsPageResponse>({
    queryKey: [GET_VISIBILITY_REPORTS, projectId, page, pageSize],
    queryFn: () => getVisibilityReports(projectId!, page, pageSize),
    enabled: projectId != null,
    staleTime: 5_000,
    refetchOnWindowFocus: false,
  });
};
